import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Auth } from '../auth/auth.service';
import { ClientRepository } from '../client.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BaseGuard implements CanActivate {

  constructor(private auth: Auth, private router: Router, private clientService: ClientRepository) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.create(observer => {
      this.auth.isAuthenticated().then((isAuthenticated) => {
        if (!isAuthenticated) {
          return false;
        }

        this.clientService.init().then(() => {
          observer.next(true);
          observer.complete();
        });
      })
    });
    /*return Observable.create(observer => {
     this.auth.isAuthenticated().then(isAuthenticated => {
     if (isAuthenticated) {
     observer.next(true);
     observer.complete();
     } else {
     this.auth.returnUrl = state.url;
     this.router.navigate(['/login']);
     observer.next(false);
     observer.complete();
     }
     });
     });*/
  }
}



// WEBPACK FOOTER //
// ./src/app/base/base.guard.ts